import { PaletteOptions } from '@mui/material/styles/createPalette';
import { TypographyOptions } from '@mui/material/styles/createTypography';
import { fabricTypography } from './fabricTypography';

export const getTypography = (palette: PaletteOptions): TypographyOptions => {
	return fabricTypography(palette);
};
